<nb-card class="wholesaler-config-dialog mb-0">
  <nb-card-header>{{ definition.displayName }} — {{ 'INVOICE_IMPORTS.SETTINGS.DIALOG_TITLE' | translate }}</nb-card-header>
  <nb-card-body>
    <div class="alert alert-danger" *ngIf="fieldErrors['_global']">{{ fieldErrors['_global'] }}</div>
    <form [formGroup]="form">
      <div class="form-check form-switch mb-3">
        <input class="form-check-input" type="checkbox" formControlName="isActive" id="wsActive" />
        <label class="form-check-label" for="wsActive">{{ 'INVOICE_IMPORTS.SETTINGS.IS_ACTIVE' | translate }}</label>
      </div>

      <div formGroupName="routing">
        <div class="mb-3" *ngFor="let field of definition.storeSetupSchema?.fields">
          <label class="form-label">{{ fieldLabel(field) }}</label>
          <input
            [type]="field.secret ? 'password' : field.type === 'number' ? 'number' : 'text'"
            class="form-control"
            [formControlName]="field.key"
            [placeholder="field.secret ? '••••' : ''" />
          <div class="form-text" *ngIf="fieldHelp(field)">{{ fieldHelp(field) }}</div>
          <div class="text-danger small" *ngIf="fieldErrors[field.key]">{{ fieldErrors[field.key] }}</div>
        </div>
      </div>

      <hr />
      <h6 class="mb-2">{{ 'INVOICE_IMPORTS.SETTINGS.REVIEW_SECTION' | translate }}</h6>
      <div class="form-check form-switch mb-3">
        <input class="form-check-input" type="checkbox" formControlName="autoApproveSmallChanges" id="autoApproveSmall" />
        <label class="form-check-label" for="autoApproveSmall">{{ 'INVOICE_IMPORTS.SETTINGS.AUTO_APPROVE_SMALL' | translate }}</label>
      </div>
      <div class="row g-2 mb-3">
        <div class="col-md-4">
          <label class="form-label">{{ 'INVOICE_IMPORTS.SETTINGS.COST_CHANGE_SMALL' | translate }}</label>
          <input type="number" class="form-control" formControlName="costChangeSmallPercent" step="0.1" />
        </div>
        <div class="col-md-4">
          <label class="form-label">{{ 'INVOICE_IMPORTS.SETTINGS.COST_CHANGE_NOTICE' | translate }}</label>
          <input type="number" class="form-control" formControlName="costChangeNoticePercent" step="0.1" />
        </div>
        <div class="col-md-4">
          <label class="form-label">{{ 'INVOICE_IMPORTS.SETTINGS.COST_CHANGE_LARGE' | translate }}</label>
          <input type="number" class="form-control" formControlName="costChangeLargePercent" step="0.1" />
        </div>
      </div>
      <div class="row g-2 mb-3">
        <div class="col-md-6">
          <label class="form-label">{{ 'INVOICE_IMPORTS.SETTINGS.MIN_MARGIN' | translate }}</label>
          <input type="number" class="form-control" formControlName="minimumMarginPercent" />
        </div>
        <div class="col-md-6">
          <label class="form-label">{{ 'INVOICE_IMPORTS.SETTINGS.MARGIN_DROP_ALERT' | translate }}</label>
          <input type="number" class="form-control" formControlName="marginDropAlertPoints" step="0.1" />
        </div>
      </div>
      <div class="mb-3">
        <label class="form-label">{{ 'INVOICE_IMPORTS.SETTINGS.COST_BASIS' | translate }}</label>
        <input class="form-control" formControlName="costPriceBasis" />
        <div class="form-text">{{ costPriceBasisLabel() }}</div>
      </div>
      <div class="mb-3">
        <label class="form-label">{{ 'INVOICE_IMPORTS.SETTINGS.COST_EPSILON' | translate }}</label>
        <input class="form-control" formControlName="costChangeEpsilon" />
      </div>
      <div class="row g-2 mb-3">
        <div class="col-md-4">
          <label class="form-label">{{ 'INVOICE_IMPORTS.PHASE2.COST_PRICE_SOURCE_LABEL' | translate }}</label>
          <select class="form-select" formControlName="costPriceSource">
            <option value="latest_invoice">{{ 'INVOICE_IMPORTS.PHASE2.COST_PRICE_SOURCE.LATEST_INVOICE' | translate }}</option>
            <option value="fifo_oldest_open">{{ 'INVOICE_IMPORTS.PHASE2.COST_PRICE_SOURCE.FIFO_OLDEST_OPEN' | translate }}</option>
          </select>
        </div>
        <div class="col-md-4">
          <div class="form-check form-switch mt-4">
            <input class="form-check-input" type="checkbox" formControlName="countDeviationBlocksAutoApprove" id="countDevBlock" />
            <label class="form-check-label" for="countDevBlock">{{ 'INVOICE_IMPORTS.PHASE2.COUNT_DEV_BLOCKS_AUTO' | translate }}</label>
          </div>
        </div>
        <div class="col-md-4">
          <label class="form-label">{{ 'INVOICE_IMPORTS.PHASE2.CREDIT_NOTE_DEFAULT' | translate }}</label>
          <select class="form-select" formControlName="creditNoteDefaultKind">
            <option value="return">{{ 'INVOICE_IMPORTS.PHASE2.CREDIT_KIND_RETURN' | translate }}</option>
            <option value="price_correction">{{ 'INVOICE_IMPORTS.PHASE2.CREDIT_KIND_PRICE' | translate }}</option>
          </select>
        </div>
      </div>

      <hr />
      <h6 class="mb-2">{{ 'INVOICE_IMPORTS.PHASE2.CATEGORY_MAPPING_TITLE' | translate }}</h6>
      <div class="mb-2" *ngFor="let row of categoryRows; let i = index">
        <div class="row g-2 align-items-end">
          <div class="col-md-4">
            <input class="form-control" [(ngModel)]="row.codePrefix" [ngModelOptions]="{ standalone: true }" [placeholder]="'INVOICE_IMPORTS.PHASE2.CODE_PREFIX' | translate" />
          </div>
          <div class="col-md-6">
            <select class="form-select" [(ngModel)]="row.categoryId" [ngModelOptions]="{ standalone: true }">
              <option value="">{{ 'INVOICE_IMPORTS.PHASE2.DRAFT_CATEGORY_PLACEHOLDER' | translate }}</option>
              <option *ngFor="let c of storeCategories" [value]="c._id">{{ c.name }}</option>
            </select>
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-outline-danger btn-sm w-100" (click)="removeCategoryRow(i)">×</button>
          </div>
        </div>
      </div>
      <button type="button" class="btn btn-sm btn-outline-secondary mb-3" (click)="addCategoryRow()">
        {{ 'INVOICE_IMPORTS.PHASE2.ADD_ROW' | translate }}
      </button>

      <h6 class="mb-2">{{ 'INVOICE_IMPORTS.PHASE2.PANT_PRODUCTS_TITLE' | translate }}</h6>
      <div class="mb-2" *ngFor="let row of pantRows; let i = index">
        <div class="row g-2">
          <div class="col-md-3">
            <input class="form-control form-control-sm" [(ngModel)]="row.supplierItemNumber" [ngModelOptions]="{ standalone: true }" placeholder="7000–7099" />
          </div>
          <div class="col-md-2">
            <select class="form-select form-select-sm" [(ngModel)]="row.pantClass" [ngModelOptions]="{ standalone: true }">
              <option value="A">A</option>
              <option value="B">B</option>
              <option value="C">C</option>
              <option value="X">X</option>
            </select>
          </div>
          <div class="col-md-5">
            <input class="form-control form-control-sm" [(ngModel)]="pantProductSearch[i]" (keyup)="searchPantProduct(i)" [ngModelOptions]="{ standalone: true }" [placeholder]="'INVOICE_IMPORTS.PHASE2.PANT_PRODUCT_SEARCH' | translate" />
            <button type="button" class="btn btn-sm btn-light w-100 text-start mt-1" *ngFor="let p of pantProductResults[i]" (click)="pickPantProduct(i, p)">
              {{ p.name }} · {{ p.barcode }}
            </button>
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-outline-danger btn-sm w-100" (click)="removePantRow(i)">×</button>
          </div>
        </div>
      </div>
      <button type="button" class="btn btn-sm btn-outline-secondary mb-3" (click)="addPantRow()">
        {{ 'INVOICE_IMPORTS.PHASE2.ADD_ROW' | translate }}
      </button>

      <ng-container *ngIf="isDagrofa">
        <hr />
        <h6 class="mb-2">{{ 'INVOICE_IMPORTS.SETTINGS.SUB_SECTION' | translate }}</h6>
        <div class="row g-2 mb-3">
          <div class="col-md-6">
            <label class="form-label">{{ 'INVOICE_IMPORTS.SETTINGS.SUB_DEFAULT_TEMP' | translate }}</label>
            <select class="form-select" formControlName="substitutionDefaultForTemporary">
              <option value="one_delivery">{{ 'INVOICE_IMPORTS.SUB.STRATEGY_ONE_DELIVERY' | translate }}</option>
              <option value="until_restock">{{ 'INVOICE_IMPORTS.SUB.STRATEGY_UNTIL_RESTOCK' | translate }}</option>
            </select>
            <div class="text-danger small" *ngIf="fieldErrors['substitution.defaultForTemporary']">
              {{ fieldErrors['substitution.defaultForTemporary'] }}
            </div>
          </div>
          <div class="col-md-6 d-flex align-items-end">
            <div class="form-check form-switch mb-2">
              <input class="form-check-input" type="checkbox" formControlName="substitutionPromptOnNewSub" id="subPromptNew" />
              <label class="form-check-label" for="subPromptNew">{{ 'INVOICE_IMPORTS.SETTINGS.SUB_PROMPT_ON_NEW' | translate }}</label>
            </div>
          </div>
        </div>

        <h6 class="mb-2">{{ 'INVOICE_IMPORTS.SETTINGS.SUB_MAPPINGS_TITLE' | translate }}</h6>
        <div class="d-flex flex-wrap gap-2 mb-2 align-items-center">
          <input
            class="form-control form-control-sm sub-mapping-search"
            [(ngModel)]="substitutionSearchQ"
            [ngModelOptions]="{ standalone: true }"
            (keyup.enter)="onSubstitutionSearch()"
            [placeholder]="'INVOICE_IMPORTS.SETTINGS.SUB_SEARCH' | translate" />
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="onSubstitutionSearch()">
            {{ 'INVOICE_IMPORTS.SETTINGS.SUB_SEARCH_BTN' | translate }}
          </button>
          <div class="form-check form-switch ms-auto">
            <input class="form-check-input" type="checkbox" [checked]="substitutionShowEnded" (change)="toggleSubstitutionShowEnded()" id="subShowEnded" />
            <label class="form-check-label" for="subShowEnded">{{ 'INVOICE_IMPORTS.SETTINGS.SUB_SHOW_ENDED' | translate }}</label>
          </div>
        </div>
        <div class="text-muted small py-2" *ngIf="substitutionLoading">{{ 'INVOICE_IMPORTS.COMMON.LOADING' | translate }}</div>
        <div class="alert alert-danger small" *ngIf="substitutionLoadError">{{ substitutionLoadError }}</div>
        <div class="text-muted small py-2" *ngIf="!substitutionLoading && !substitutionLoadError && !substitutionItems.length">
          {{ 'INVOICE_IMPORTS.SETTINGS.SUB_EMPTY' | translate }}
        </div>
        <div class="table-responsive mb-2" *ngIf="substitutionItems.length">
          <table class="table table-sm align-middle sub-mapping-table">
            <thead>
              <tr class="small">
                <th>{{ 'INVOICE_IMPORTS.SETTINGS.SUB_COL_FROM' | translate }}</th>
                <th>{{ 'INVOICE_IMPORTS.SETTINGS.SUB_COL_TO' | translate }}</th>
                <th>{{ 'INVOICE_IMPORTS.SETTINGS.SUB_COL_STRATEGY' | translate }}</th>
                <th>{{ 'INVOICE_IMPORTS.SETTINGS.SUB_COL_STATUS' | translate }}</th>
                <th>{{ 'INVOICE_IMPORTS.SETTINGS.SUB_COL_SOURCE' | translate }}</th>
                <th>{{ 'INVOICE_IMPORTS.SETTINGS.SUB_COL_CREATED' | translate }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of substitutionItems">
                <td class="small">{{ item.fromSupplierItemNumber || item.fromEan || '—' }} · {{ item.fromName || '—' }}</td>
                <td class="small">{{ item.toSupplierItemNumber || item.toEan || '—' }} · {{ item.toName || '—' }}</td>
                <td>
                  <select
                    class="form-select form-select-sm"
                    [ngModel]="item.strategy"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="patchSubstitutionStrategy(item, $event)"
                    [disabled]="item.isActive === false">
                    <option *ngFor="let s of substitutionStrategies" [ngValue]="s">{{ substitutionStrategyLabel(s) }}</option>
                  </select>
                </td>
                <td class="small">{{ item.statusText || '—' }}</td>
                <td class="small">{{ substitutionSourceLabel(item) }}</td>
                <td class="small">{{ item.createdAt | date:'short' }}</td>
                <td>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-primary me-1"
                    *ngIf="item.isActive !== false"
                    (click)="editSubstitutionMapping(item)">
                    {{ 'INVOICE_IMPORTS.SUB.EDIT_MAPPING' | translate }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-danger"
                    *ngIf="item.isActive !== false"
                    (click)="endSubstitution(item)">
                    {{ 'INVOICE_IMPORTS.SETTINGS.SUB_END' | translate }}
                  </button>
                  <span class="badge bg-secondary" *ngIf="item.isActive === false">{{ 'INVOICE_IMPORTS.SETTINGS.SUB_ENDED' | translate }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-between align-items-center small mb-3" *ngIf="substitutionTotal > substitutionLimit">
          <span>{{ 'INVOICE_IMPORTS.SETTINGS.SUB_PAGE' | translate:{ page: substitutionPage, total: substitutionTotalPages() } }}</span>
          <div class="btn-group btn-group-sm">
            <button type="button" class="btn btn-outline-secondary" (click)="substitutionPrevPage()" [disabled]="substitutionPage <= 1">‹</button>
            <button type="button" class="btn btn-outline-secondary" (click)="substitutionNextPage()" [disabled]="substitutionPage >= substitutionTotalPages()">›</button>
          </div>
        </div>
      </ng-container>

      <hr />
      <h6 class="mb-2">{{ 'INVOICE_IMPORTS.PHASE2.ENRICHMENT_TITLE' | translate }}</h6>
      <div class="form-check form-switch mb-2">
        <input class="form-check-input" type="checkbox" formControlName="enrichmentEnabled" id="enrichEnabled" />
        <label class="form-check-label" for="enrichEnabled">{{ 'INVOICE_IMPORTS.PHASE2.ENRICHMENT_ENABLED' | translate }}</label>
      </div>
      <div class="row g-2 mb-2">
        <div class="col-md-4">
          <label class="form-label">{{ 'INVOICE_IMPORTS.PHASE2.ENRICHMENT_PULL_MODE' | translate }}</label>
          <select class="form-select" formControlName="enrichmentPullMode">
            <option value="list_only">{{ 'INVOICE_IMPORTS.PHASE2.PULL_LIST_ONLY' | translate }}</option>
            <option value="list_download">{{ 'INVOICE_IMPORTS.PHASE2.PULL_LIST_DOWNLOAD' | translate }}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label class="form-label">{{ 'INVOICE_IMPORTS.PHASE2.ENRICHMENT_PROTOCOL' | translate }}</label>
          <select class="form-select" formControlName="enrichmentProtocol">
            <option value="ftp">FTP</option>
            <option value="ftps">FTPS</option>
            <option value="sftp">SFTP</option>
          </select>
        </div>
        <div class="col-md-4">
          <label class="form-label">{{ 'INVOICE_IMPORTS.PHASE2.ENRICHMENT_PORT' | translate }}</label>
          <input type="number" class="form-control" formControlName="enrichmentPort" />
        </div>
        <div class="col-md-6">
          <label class="form-label">{{ 'INVOICE_IMPORTS.PHASE2.ENRICHMENT_HOST' | translate }}</label>
          <input class="form-control" formControlName="enrichmentHost" />
        </div>
        <div class="col-md-6">
          <label class="form-label">{{ 'INVOICE_IMPORTS.PHASE2.ENRICHMENT_USERNAME' | translate }}</label>
          <input class="form-control" formControlName="enrichmentUsername" />
        </div>
        <div class="col-md-6">
          <label class="form-label">{{ 'INVOICE_IMPORTS.PHASE2.ENRICHMENT_PASSWORD' | translate }}</label>
          <input type="password" class="form-control" formControlName="enrichmentPassword" autocomplete="new-password" />
        </div>
        <div class="col-md-6">
          <label class="form-label">{{ 'INVOICE_IMPORTS.PHASE2.ENRICHMENT_REMOTE_DIR' | translate }}</label>
          <input class="form-control" formControlName="enrichmentRemoteDir" />
        </div>
        <div class="col-12">
          <label class="form-label">{{ 'INVOICE_IMPORTS.PHASE2.ENRICHMENT_FILE_PATTERN' | translate }}</label>
          <input class="form-control" formControlName="enrichmentFilePattern" />
        </div>
      </div>
      <div class="d-flex flex-wrap gap-2 mb-2" *ngIf="definition?.supplierKey">
        <button type="button" class="btn btn-sm btn-outline-primary" (click)="testEnrichmentConnection()">
          {{ 'INVOICE_IMPORTS.PHASE2.ENRICHMENT_TEST' | translate }}
        </button>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="pullEnrichmentNow(false)">
          {{ 'INVOICE_IMPORTS.PHASE2.ENRICHMENT_PULL' | translate }}
        </button>
      </div>
      <div class="alert alert-danger small" *ngIf="enrichmentActionError">{{ enrichmentActionError }}</div>
      <div class="small text-muted mb-3" *ngIf="enrichmentStatus">
        <div>{{ 'INVOICE_IMPORTS.PHASE2.ENRICHMENT_LAST_PULL' | translate }}: {{ enrichmentStatus.lastPullAt || '—' }}</div>
        <div>{{ enrichmentStatus.lastPullStatus }} · {{ enrichmentStatus.lastPullError }}</div>
        <ul class="mb-0 ps-3" *ngIf="enrichmentStatus.recentFiles?.length">
          <li *ngFor="let f of enrichmentStatus.recentFiles">{{ f.remotePath }} ({{ f.status }})</li>
        </ul>
      </div>

      <label class="form-label">{{ 'INVOICE_IMPORTS.SETTINGS.APPROVED_SENDERS' | translate }}</label>
      <div class="input-group mb-2">
        <input class="form-control" [(ngModel)]="addressInput" [ngModelOptions]="{ standalone: true }" (keyup.enter)="addAddress()" />
        <button type="button" class="btn btn-outline-secondary" (click)="addAddress()">+</button>
      </div>
      <span class="badge bg-light text-dark me-1 mb-3" *ngFor="let a of approvedAddresses; let i = index">
        {{ a }}
        <button type="button" class="btn-close btn-close-sm ms-1" (click)="removeAddress(i)"></button>
      </span>
    </form>
  </nb-card-body>
  <nb-card-footer class="d-flex justify-content-end gap-2">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">{{ 'INVOICE_IMPORTS.COMMON.CANCEL' | translate }}</button>
    <button type="button" class="btn btn-primary" (click)="save()">{{ 'INVOICE_IMPORTS.COMMON.SAVE' | translate }}</button>
  </nb-card-footer>
</nb-card>
